import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { PageHeader } from "@/components/ui-bits";
import { useLang } from "@/lib/i18n";

export const Faq = () => {
  const { t } = useLang();
  const FAQS = t("faq.items", []);
  const [open, setOpen] = useState(0);

  return (
    <div className="px-6 sm:px-12 lg:px-20 pt-32 pb-24 max-w-4xl">
      <PageHeader
        eyebrow={t("faq.eyebrow")}
        title={<>Veelgestelde <span className="italic normal-case text-gold">{t("faq.title2")}</span></>}
        sub={t("faq.sub")}
      />
      <div className="space-y-3">
        {FAQS.map(([q, a], i) => (
          <div key={i} data-testid={`faq-item-${i}`} className="border border-gold/15 bg-ink">
            <button data-testid={`faq-toggle-${i}`} onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-6 text-left">
              <span className="font-serif text-lg text-cream">{q}</span>
              <ChevronDown size={16} className={`text-gold shrink-0 transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && (
              <p data-testid={`faq-answer-${i}`} className="px-6 pb-6 text-sm text-mist leading-relaxed">{a}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
